module.exports = __webpack_public_path__ + "static/media/galeria11.9803f099.jpg";